import { useAuth } from "../hooks/AuthProvider.js";

const Logout = () => {
  const auth = useAuth();
  auth.logout();
};

export default Logout;